import React from 'react'

const Divider = ({ text, className = "" }) => {
  return (
    <div className={`my-6 ${className}`}>
      <div className="w-full border-t border-white/20 mb-2"></div>
      {text && (
        <div className="flex justify-center text-sm">
          <span className="text-gray-400">{text}</span>
        </div>
      )}
    </div>
  )
}

export default Divider